// extracted by mini-css-extract-plugin
export default {"title":"order-complete-view_title__fbDpc","message":"order-complete-view_message__PPP5-"};